import { render, staticRenderFns } from "./TableDetailInfo.vue?vue&type=template&id=1165c391&"
import script from "./TableDetailInfo.vue?vue&type=script&lang=js&"
export * from "./TableDetailInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports